
$('#myDropdown .dropdown-menu').on({
	"click":function(e){
      e.stopPropagation();
    }
});
$(function() {
	$('a[href*=#]:not([href=#])').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {

			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top
				}, 1000);
				return false;
			}
		}
	});
});
 

// jQuery(document).ready(function($) {
//            $('.parallax').parallax();
//        })
//
		

var propiedad_auxiliar = "Es para los ajustes css y js";


//********************************************
//
//	Copyright Mobifriends S.L. 2007
//	
//	programador: Javier Velasco Gonzalez	
//
//********************************************


var interval=0;

function onLenguajeMouseOn() {
	Show('ch_idioma_options',true);
	if (interval) clearInterval(interval);
	interval = 0;
}

function onLenguajeClickOn() {
	SwapShow('ch_idioma_options');
	if (interval) clearInterval(interval);
	interval = 0;
}

function hideLenguajeBox() {
	Show('ch_idioma_options',false);
	if (interval) clearInterval(interval);
	interval = 0;
}

function onLenguajeBoxMouseOut() {
	if (interval>0) return;
	interval = setInterval("hideLenguajeBox()",500);
}

function setPreferencia(link){
	var newLink = link.href + '?setLang=1';
	link.href = newLink;
	
	return true;
}

// Clear user and password fields, password type is changed to password.
// This function supports Mozilla Firefox and Explorer 6 and 7.
function prepare_login_form() {
	uc = document.getElementById("user");
	uc.value = "";
	pc = document.getElementById("password");
    pc.value = "1"; //fix chrome autofill password but dom value  ""
	pc.value = "";
}

function changeCountry(countryName){
	document.getElementById('countryName').value = countryName;
}

function cambiaQueEste() {
	qediv = document.getElementById("queeste_div");
	provdiv = document.getElementById("provincia_div");
	qediv.style.visibility = 'hidden';
	qediv.style.height = '0px';
	provdiv.style.visibility = 'visible';
	provdiv.style.height = '100%';
}

function volverQueEste(locationlevel) {
    // Intente pasar un string pero al generarse en index_form no pude pasarlo ni con \" o \'
    // 1 = pais; 2 = provincia; 3 = poblacion
    document.getElementById('renderRegions').value = 0;
    if(locationlevel != 3){
        // No actualizar si es poblacion
        provincia = document.getElementById("provincia");
        provincia.selectedIndex = 0;
    }
    country = document.getElementById("country");
    country.selectedIndex = 0;
    busquedaPresentacion0();
    document.getElementById('renderRegions').value = 1;

    qediv = document.getElementById("queeste_div");
    provdiv = document.getElementById("provincia_div");
    qediv.style.visibility = 'visible';
    qediv.style.height = '100%';
    provdiv.style.visibility = 'hidden';
    provdiv.style.height = '0px';
}

function cancelRegister() {
}
	

function continuarSubirFoto() {
}



//********************************************
//
//	Copyright Mobifriends S.L. 2007
//	
//	programador: Javier Velasco Gonzalez	
//
//********************************************

//********************************************
// devuelve la version de explorer o 0.
//--------------------------------------------
 
function isExplorer() {
	if (navigator.appName=="Microsoft Internet Explorer") {
		var iversion = navigator.appVersion.indexOf("MSIE ");
		if (iversion>0) {
			iversion+=5;
			var eversion = navigator.appVersion.indexOf(";",iversion);
			var version = navigator.appVersion.substring(iversion,eversion);
			return parseInt(version);
		}
	} else return 0;
}

//********************************************
// devuelve la version de firefox o 0.
//--------------------------------------------
function isFirefox() {
	if (navigator.appName.indexOf("Netscape")!=-1 && parseInt(navigator.appVersion)>=5) {
		var iversion = navigator.userAgent.indexOf("Firefox/");
		if (iversion>0) {
			iversion+=8;
			var eversion = navigator.userAgent.indexOf(" ",iversion);
			if (eversion<navigator.userAgent.length) eversion = navigator.userAgent.length;
			var version = navigator.userAgent.substring(iversion,iversion + 1000);
			return parseInt(version);
		} else return 0;
	}
	else return 0;
}


function getWindowWidth() {
  var width = 0;
  if( typeof( window.innerWidth ) == 'number' ) {
    //Non-IE
    if( document.body && document.body.clientWidth) width = document.body.clientWidth;
    else width = window.innerWidth;
  } else if( document.documentElement && document.documentElement.clientWidth) {
    //IE 6+ in 'standards compliant mode'
    width = document.documentElement.clientWidth;
  } else if( document.body && document.body.clientWidth) {
    //IE 4 compatible
    width = document.body.clientWidth;
  }
  return width;
}

function getWindowHeight() {
  var height = 0;
  if( typeof( window.innerWidth ) == 'number' ) {
    //Non-IE
    if( document.body && document.body.clientHeighth) height = document.body.clientHeight;
    else height = window.innerHeight;
  } else if( document.documentElement && document.documentElement.clientHeight ) {
    //IE 6+ in 'standards compliant mode'
    height = document.documentElement.clientHeight;
  } else if( document.body && document.body.clientHeight ) {
    //IE 4 compatible
    height = document.body.clientHeight;
  }
  return height;
}


function getDocumentHeight() {
	var height = document.height;
	//if (!height) height = document.docubody.clientHeight;
	if (!height) height = document.documentElement.scrollHeight;

	if (height<getWindowHeight()) height = getWindowHeight();

	return height;
}


function getDocumentWidth() {
	var width = document.width;
//	if (!width) width = document.body.clientWidth;
	if (!width) width = document.documentElement.scrollWidth;
	if (width<getWindowWidth()) width = getWindowWidth();
	return width;
}

function getHScrollPos() {
	var vExplorer = isExplorer();
	var pos;
	if (vExplorer) {
		pos = document.documentElement.scrollLeft;
		if (!pos) pos = document.body.scrollLeft;
	} else {
		pos=window.pageXOffset;		
	}
	return pos;	
}

function getVScrollPos() {
	var vExplorer = isExplorer();
	var pos;
	if (vExplorer) {
		pos = document.documentElement.scrollTop;
		if (!pos) pos = document.body.scrollTop;
	} else {
		pos=window.pageYOffset;		
	}
	return pos;	
}

function getVScrollAdjustments() {
	var screenHeight = getWindowHeight();
	var vScrollPos =  getVScrollPos();
	return screenHeight +"," +vScrollPos;
}


//********************************************
// envia el formulario con el id = formid.
//--------------------------------------------
//
// @params:
//	formid: attributo id del form.
//
// @return: 
//
//********************************************
function submitFormById(formid,enabledloader) {
	if (enabledloader) {
		var wwidth = getWindowWidth();
		var wheight = getWindowHeight();
		CreateWindow("backgroundloader","0px","0px",wwidth + "px",wheight + "px","",null,"30");
		CreateWindow("ajaxloader","0px","0px",wwidth + "px","32px",sLoadingMessage,null,sLoadingOpacity,"loading-window");		
	}

	f = document.getElementById(formid)
	f.submit();
}

//********************************************
// devuelve el valor de un campo.
//--------------------------------------------
//
// @params:
//	id: id del campo.
//
// @return: 
//	devuelve el valor de un campo en funcion de el id.
//
//********************************************
function getValue(id) {
	f = document.getElementById(id);
	return f.value;
}

//********************************************
// establece el valor de un campo.
//--------------------------------------------
//
// @params:
//	id: id del campo.
//
// @return: 
//
//********************************************
function setValue(id,value) {
	f = document.getElementById(id);
	if (f==null) return;
	switch (f.tagName.toLowerCase()) {
		case "select":
			f.value = value;
		break;
		case "input":
			f.value = value;
			if (f.type=="checkbox") {
				if (value==0) f.checked = null;
				else f.checked= true;
			}
		break;
		case "div":
			otype = document.getElementById(id+"__type");
			olenght = document.getElementById(id+"__length");
			if (otype==null) return;
			switch (otype.value) {
				case "mcheckbox":
					for (i=0;i<olenght.value;i++) {
						o = document.getElementById(id+String(i));
						if (o.value==value) {
							o.checked = true;
							return;
						}
					}
				break;				
			}
		break;
	}
}


//********************************************
// limpia los checkboxes 
//--------------------------------------------
//
// @params:
//	id: id del multiple checkbox.
//
// @return: 
//
//********************************************
function clearMCheckbox(id) {
	f = document.getElementById(id);
	if (f==null) return;
	otype = document.getElementById(id+"__type");
	olenght = document.getElementById(id+"__length");
	if (otype==null || otype.value!="mcheckbox") return;
	for (i=0;i<olenght.value;i++) {
		o = document.getElementById(id+String(i));
		o.checked=null;
	}
}

//********************************************
// borra todas las referencias dentro de un objeto
// de forma recursiva.
// Se usa para prevenir el memory leak de explorer,
// tiene que ser llamada antes de un setInnerHTML
// y antes de un removeChild.
//--------------------------------------------
function purge(d) {
    var a = d.attributes, i, l, n;
    if (a) {
        l = a.length;
        for (i = 0; i < l; i += 1) {
        	try{
            	n = a[i].name;
            }catch(e){
            	return;
            }
            if (typeof d[n] === 'function') {
                d[n] = null;
            }
        }
    }
    a = d.childNodes;
    if (a) {
        l = a.length;
        for (i = 0; i < l; i += 1) {
            purge(d.childNodes[i]);
        }
    }
}
//********************************************
// establece el html dentro de una etiqueta.
//--------------------------------------------
//
// @params:
//	id: id del campo.
//
// @return: 
//
//********************************************
function setInnerHTML(id,text) {
	f = document.getElementById(id);
	if (f==null) return;//alert("No encuentra" + id);
	else {
		if (isExplorer()) purge(f);
		f.innerHTML = text;
	}
}


function urldecode( str ) {
    var histogram = {}, histogram_r = {}, code = 0, str_tmp = [];
    var ret = str.toString();
    
    var replacer = function(search, replace, str) {
        var tmp_arr = [];
        tmp_arr = str.split(search);
        return tmp_arr.join(replace);
    };
    
    histogram['!']   = '%21';
    histogram['%20'] = '+';
    
    for (replace in histogram) {
        search = histogram[replace]; // Switch order when decoding
        ret = replacer(search, replace, ret) // Custom replace. No regexing   
    }
    
    ret = decodeURIComponent(ret);
    return ret;
}

function striptags(str) {
	var flip = false;
	var result="";
	for (c in str) {
		if (str[c]=='<') flip=true;
		else if (str[c]=='>') flip=false;
		else if (!flip) result+=str[c];
	}
	return result;
}


function setInnerEHTML(id,text) {
	f = document.getElementById(id);
	if (f==null) return; //alert("No encuentra" + id);
	else {
		purge(f);
		f.innerHTML = urldecode(text);
	}
}


//Rellena un campo select con valores numericos.
function fillNumbersCombo(id,nini,nfin,value,rellenarconceros) {
	options = "";
	snfin = nfin.toString();
	snini = nini.toString();
	maxlen = snfin.length;
	if (snini.length>maxlen) maxlen = snini.length ;
	/*
	for (i=nini;;) {
		stri = i.toString();
		if (rellenarconceros) {
			len = stri.length;
			for (j=0;j<maxlen-len;j++) stri = "0"+stri;
		}
		if (value!=i) options += "<option value='" + i.toString()+"'>" + stri + "</option>";
		else options += "<option selected='true' value='" + i.toString()+"'>" + stri + "</option>";
		//test del loop.		
		if (nini<nfin) {
			if (i>=nfin) break;
			i++
		} else {
			if (i<=nfin) break;
			i--;
		}
	}*/
	setInnerHTML(id,options);
}

//********************************************
// devuelve el valor de un elemento del tipo INPUT.
//--------------------------------------------
//
// @params:
//	fieldid: id del elemento INPUT.
//
// @return: 
//	devuelve una cadena con el valor del INPUT
//
//********************************************
function getInputValueById(fieldid) {
	f = document.getElementById(fieldid)
	return f.value;
}

//********************************************
// cambia el elemento seleccionado en un SELECT.
//--------------------------------------------
//
// @params:
//	formid: attributo id del form.
//	comboname: nombre del campo SELECT.
//	value: attributo value del OPTION a seleccionar.
//
// @return: 
//	devuelve una cadena con el valor del INPUT
//
//********************************************
function setComboByValue(formid,comboname,value) {
	f = document.getElementById(formid)
	if(typeof XMLHttpRequest!='undefined') {
		element = f.elements[comboname];
	} else {
		element = f.all[comboname];
	}
	var attrs="";
	for (i=0;i<element.length;i++) {
		var option = element[i];
		if (option.tagName=="OPTION" && 
			option.value==value) {
			element.selectedIndex=i;
		} 
	}
}

//********************************************
// cambia el elemento seleccionado en un SELECT.
//--------------------------------------------
//
// @params:
//	formid: attributo id del form.
//	comboname: nombre del campo SELECT.
//	text: texto de la opcion a seleccionar.
//
// @return: 
//
//********************************************
function setComboByText(formid,comboname,text) {
	f = document.getElementById(formid)
	if(typeof XMLHttpRequest!='undefined') {
		element = f.elements[comboname];
	} else {
		element = f.all[comboname];
	}
	var attrs="";
	for (i=0;i<element.length;i++) {
		var option = element[i];
		if (option.tagName=="OPTION" && 
			option.innerText==text) {
			element.selectedIndex=i;
		} 
	}
}

//********************************************
// establece el valor de un campo INPUT.
//--------------------------------------------
//
// @params:
//	formid: attributo id del form.
//	fieldname: nombre del campo INPUT.
//	value: valor para el campo INPUT.
//
// @return: 
//
//********************************************
function setInput(formid,fieldname,value) {
	f = document.getElementById(formid)
	if(typeof XMLHttpRequest!='undefined') {
		element = f.elements[fieldname];
	} else {
		element = f.all[fieldname];
	}
	element.value = value;
}

//********************************************
// devuelve el estilo de un elemento.
//--------------------------------------------
//
// @params:
//	id: attributo id del elemento.
//
// @return: 
//
//********************************************
function getStyleById(id) {
	element = document.getElementById(id)
	return element.style;
}


//Funciones de validacion

//********************************************
// valida que sea una direccion de correo valida.
//--------------------------------------------
//
// @params:
//	email: cadena de texto que contiene el email.
//
// @return: 
//	true si es correcta o false si es incorrecta.
//
//********************************************
function validateEmail(email) {
	var parts = email.split('@');
	if (parts.length!=2) return false;
	var user = parts[0];
	var server = parts[1];
	parts = server.split('.');
	if (parts.length<1) return false;
	else return true;
}

//********************************************
// valida que sea un numero.
//--------------------------------------------
//
// @params:
//	number: cadena de texto que contiene el numero.
//
// @return: 
//	true si es correcta o false si es incorrecta.
//
//********************************************
function validateIsNumber(number) {
	for (i=0;i<number.length;i++) {
		var ch = number.charAt(i);
		if (ch!='0' && ch!='1' && ch!='2' && ch!='3' && ch!='4' && ch!='5' && ch!='6' && ch!='7' && ch!='8' && ch!='9')
		return false;
	}
	return true;
}

//********************************************
// valida que sea un numero de telefono valido.
//--------------------------------------------
//
// @params:
//	number: cadena de texto que contiene el numero.
//
// @return: 
//	true si es correcta o false si es incorrecta.
//
//********************************************
function validateIsPhoneNumber(number) {
	for (i=0;i<number.length;i++) {
		var ch = number.charAt(i);
		if (ch!='0' && ch!='1' && ch!='2' && ch!='3' && ch!='4' && ch!='5' && ch!='6' && ch!='7' && ch!='8' && ch!='9')
		return false;
	}
	return true;
}


var WINDOW_TYPE_MODAL=1;
var WINDOW_HCENTERED=2;
var WINDOW_VCENTERED=4;

var __windows = new Array();
var __zIndex = 1000;

function CreateIFrame(id,x,y,width,height,color,opac) {
        var windowdiv = document.createElement('iframe');
        windowdiv.setAttribute('id',id);
        windowdiv.setAttribute('class',"windowiframe");
        windowdiv.src='javascript:false;';
        zi = __zIndex++;
        var div = document.getElementsByTagName("body")[0];
        if (opac!=null) windowdiv.style.filter = "alpha(opacity=" + opac + ")";
        windowdiv.style.position="absolute";
        windowdiv.style.zIndex=zi;
        windowdiv.style.top=y;
        windowdiv.style.left=x;
        if (width!=null)  windowdiv.style.width=width;
        if (height!=null) windowdiv.style.height=height;
        if (color!=null) windowdiv.style.background = color;
        div.appendChild(windowdiv);
        __windows.push(windowdiv);
}


var allSelects = new Array(); //fix Explorer 6, array con los selects.
var activeWindows = 0; // for fix window mode on flash objects in IE
//********************************************
// Crea una div dinamicamente
//--------------------------------------------
//
// @params:
//	id: atributo id de la div.
//	x: posicion x dentro de la ventana, debe ser expresada como cadena indicando la unidad %,px etc.
//	y: posicion y dentro de la ventana, debe ser expresada como cadena indicando la unidad %,px etc
//	width: ancho de la ventana, debe ser expresada como cadena indicando la unidad %,px etc
//	height: alto de la ventana, debe ser expresada como cadena indicando la unidad %,px etc
//	html: contenido xhtml de la div.
//	color: color de fondo si lo tuviera sino el atributo es omitido (transparente).
//	opac: opacidad de la capa indicado en %.
//
// @return: 
//
//********************************************
function CreateWindow(id,x,y,width,height,html,color,opac,sClassName) {
	
	var windowdiv = document.createElement('div');
	var vExplorer = isExplorer();
	var windowClass = "string" === typeof sClassName ? sClassName:"window";
	
	windowdiv.setAttribute('id',id);
	windowdiv.setAttribute('class',windowClass);
	__zIndex+=500;
	zi = __zIndex;
	var div = document.getElementsByTagName("body")[0];

	windowdiv.innerHTML = html;
	if (vExplorer==7 || vExplorer==6) {windowdiv.innerHTML="<div class='"+windowClass+"'>"+html+"</div>";}
	if (isFirefox()) {
	    if (opac!=null) {
	    	fopac = opac/100;
	    	windowdiv.style.MozOpacity=fopac;
	    }
	} 
	if (vExplorer>6) {
		if (opac!=null) windowdiv.style.filter = "alpha(opacity=" + opac + ")";
		windowdiv.style.position="absolute";
		
	} else if (vExplorer<=6 && vExplorer>3) {
		if (opac!=null) {windowdiv.style.filter = "alpha(opacity=" + opac + ")";}
		windowdiv.style.background="#FFF";
		windowdiv.style.position="absolute";
	} else {
		windowdiv.style.position="fixed";
	}
	//añadidos para cambiar la opacity de Opera y Safari
	//como no hay funcion para detectar estos navegadores y no afecta a los otros lo he puesto directamente aqui.
	if (opac!=null) {
	  	fopac = opac/100;
	   	windowdiv.style.opacity=fopac;
	}

	windowdiv.style.display="block";
	windowdiv.style.top=y;
	windowdiv.style.left=x;
	
	if (vExplorer>=8) {
		div.style.zIndex=10;
		windowdiv.style.zIndex=zi;
	} else {
		windowdiv.style.zIndex=zi;
	}
	if (width!=null)  windowdiv.style.width=width;
	if (height!=null) windowdiv.style.height=height;
	if (color!=null) windowdiv.style.background = color;
		
	div.appendChild(windowdiv);
}

function updateFlashHeaderDetails() {
  // Probando en Chrome 33, Firefox 27, IE8, Opera y funciona con FlashHead en todos los navegadores
  /*
	var isIE  = (navigator.appVersion.indexOf("MSIE") !== -1) ? true : false;
	var isWin = (navigator.appVersion.toLowerCase().indexOf("win") !== -1) ? true : false;
	var isOpera = (navigator.userAgent.indexOf("Opera") !== -1) ? true : false;
	var fo = document.getElementById("FlashHead");
	if (isIE && isWin && !isOpera) {
		fo = document.getElementById("FlashHead");
	} else {
		fo = document.getElementById("mzFlashHead");
	}
	*/
  fo = document.getElementById("FlashHead");
	try {
		fo.headRefreshData();
	} catch (ex) {}	

}

function updateFlashHeaderWindowMode(wmode){
}

function CreateIEWindow(id,x,y,width,height,html,color,opac) {
	var windowdiv = document.createElement('div');
	var vExplorer = isExplorer();
	windowdiv.setAttribute('id',id + "_parent");
	//windowdiv.setAttribute('class',"window");
	
	var div = document.getElementsByTagName("body")[0];
	if (opac!=null) windowdiv.style.filter = "alpha(opacity=" + opac + ")";
	windowdiv.style.position="absolute";
	//a�adidos para cambiar la opacity de Opera y Safari
	//como no hay funcion para detectar estos navegadores y no afecta a los otros lo he puesto directamente aqui.
	if (opac!=null) {
	  	fopac = opac/100;
	   	windowdiv.style.opacity=fopac;
	}
	divzi = __zIndex++;
	zi = __zIndex++;
	html = "<iframe style='position:absolute; "+
			" src='javascript:false;'" + 
			" top:0px;" + 
			" left:0px;" + 
			" width: 1px;" + 
			" height: 1px;" +
			" z-index: " + zi + ";'" + 
			" id='" + id + "_iframe' >'</iframe>";
	zi = __zIndex++;
	html = html + "<div style='position:absolute; top:0px; left:0px; " + 
			"z-index:" + zi +";' id='" + id + "' ></div>";	
	windowdiv.innerHTML = html;
	windowdiv.style.display="block";
	windowdiv.style.zIndex=divzi;
	windowdiv.style.top=y;
	windowdiv.style.left=x;
	if (width!=null)  windowdiv.style.width=width;
	if (height!=null) windowdiv.style.height=height;
	if (color!=null) windowdiv.style.background = color;
	div.appendChild(windowdiv);
	__windows.push(windowdiv);
	iframe = document.getElementById(id+"_iframe");
	newdiv = document.getElementById(id);
	iframe.style.width = newdiv.clientWidth;
	iframe.style.height = newdiv.clientHeight;
}


var __window_selected=null;


// Global variables
xMousePos = 0; // Horizontal position of the mouse on the screen
yMousePos = 0; // Vertical position of the mouse on the screen
xStartPos = null; // Horizontal position of the mouse on the screen
yStartPos = null; // Vertical position of the mouse on the screen

function captureMousePosition(e) {
	var vExplorer = isExplorer();
	if (!e) e = window.event;
	if (!e.pageX) {
    	xMousePos = e.clientX;
    	yMousePos = e.clientY;
    	
	} else {
    	xMousePos = e.pageX;
    	yMousePos = e.pageY;
	}
	window.status="x:" + xMousePos + " y:" + yMousePos;
	//setInnerHTML('debug',xMousePos + "," + yMousePos)
}

function MoveWindow(e) {
	captureMousePosition(e);	
	if (!xStartPos) {
		xStartPos = xMousePos;
		yStartPos = yMousePos;
	}
    if (__window_selected!=null) {
    	x = parseInt(__window_selected.style.left) + xMousePos - xStartPos;
    	y = parseInt(__window_selected.style.top) + yMousePos - yStartPos;
   		__window_selected.style.left = x + "px";
		__window_selected.style.top = y + "px";
    }
	xStartPos = xMousePos;
	yStartPos = yMousePos;
}


function StartMoveWindow(id) {
	var vExplorer = isExplorer();
	if (vExplorer==6) id=id+"_parent";
	
	//RaiseWindow(id);
	xStartPos = null;
	__window_selected = document.getElementById(id);
	if (document.layers) { // Netscape
	    document.onmousemove = MoveWindow;
    	document.onmouseup = StopMoveWindow;
	} else if (document.all) { // Internet Explorer
	    document.onmousemove = MoveWindow;
    	document.onmouseup = StopMoveWindow;
	} else if (document.getElementById) { // Netcsape 6
    	document.onmousemove = MoveWindow;
    	document.onmouseup = StopMoveWindow;
	}
}

var ic=0;
function testScroll(e) {
	setInnerHTML('debug',ic + ":=" + getHScrollPos() + "," + getVScrollPos() + "  " + getDocumentWidth() + "x" + getDocumentHeight());
	ic++;
}

function StopMoveWindow(id) {
    document.onmousemove = null;
    document.onmouseup = null;
	__window_selected = null;
}



function CreateURLWindow(id,x,y,url) {
	activeWindows=1;

	if(isExplorer()>0){
		y += getVScrollPos();
	}
	
	var wwidth = getDocumentWidth();
	var wheight = getDocumentHeight();
	
	var vExplorer = isExplorer();
	var cx = 0;
	var cy = 0;
	// This window will never be destroyed so decrement activeWindows
	CreateWindow(id + "bg","0px","0px",wwidth + "px",wheight + "px","","#000000","30");
	//if (vExplorer==6) CreateIFrame(id + "bg","0px","0px",wwidth + "px",wheight + "px","#000000","30");
	//else CreateWindow(id + "bg","0px","0px",wwidth + "px",wheight + "px","","#000000","30");
	if (vExplorer==6) {
		//CreateIEWindow(id,x + 'px',y + 'px',null,null,"",null,null);
		CreateWindow(id,x + 'px',y + 'px',null,null,"",null,null);
		//Vamos a ocultar todos los select visibles y ponerlos en un array.
		allSelects[id] = new Array();
		selects = document.getElementsByTagName('select');
		for (i=0;i<selects.length;i++) {
			if (selects[i].style.visibility!='hidden') {
				allSelects[id].push(selects[i]);
				selects[i].style.visibility='hidden';
			}
		}
	}
	else {
		CreateWindow(id,x + 'px',y + 'px',null,null,"",null,null);
	}
	ajax_call(id,url,null);
}


function CreateStaticWindow(id,x,y, title, msg, closeButtonText) {
    activeWindows=1;

    if(isExplorer()>0){
        y += getVScrollPos();
    }

    var wwidth = getDocumentWidth();
    var wheight = getDocumentHeight();

    var vExplorer = isExplorer();
    var cx = 0;
    var cy = 0;
    // This window will never be destroyed so decrement activeWindows
    CreateWindow(id + "bg","0px","0px",wwidth + "px",wheight + "px","","#000000","30");
    //if (vExplorer==6) CreateIFrame(id + "bg","0px","0px",wwidth + "px",wheight + "px","#000000","30");
    //else CreateWindow(id + "bg","0px","0px",wwidth + "px",wheight + "px","","#000000","30");

    var content = '<div id="infopopup">' +
        '<div id="cerrar"><a id="boton_cerrar_popup" href="javascript:DestroyWindow(\''+id+'\');"><img src="/images/1/popups/cerrar.gif" /></a></div><div id="titulo_crear_carpeta" class="titulo" onmousedown="StartMoveWindow(\''+id+'\');" onmouseup="StopMoveWindow(\''+id+'\');" >' +title+ '</div>	<div class="texto">' +
        msg +'</div>' +
        '<div id="botones">' +
        '<a id="boton" href="javascript:DestroyWindow(\''+id+'\');" class="botpopups">'+closeButtonText+'</a>' +
        '</div>' +
        '</div>';

    if (vExplorer==6) {
        //CreateIEWindow(id,x + 'px',y + 'px',null,null,"",null,null);
        CreateWindow(id,x + 'px',y + 'px',null,null,content,null,null);
        //Vamos a ocultar todos los select visibles y ponerlos en un array.
        allSelects[id] = new Array();
        selects = document.getElementsByTagName('select');
        for (i=0;i<selects.length;i++) {
            if (selects[i].style.visibility!='hidden') {
                allSelects[id].push(selects[i]);
                selects[i].style.visibility='hidden';
            }
        }
    }
    else {
        CreateWindow(id,x + 'px',y + 'px',null,null,content,null,null);
    }
}


//********************************************
// pone una ventana en primer plano.
//--------------------------------------------
//
// @params:
//	id: id del elemento.
//
// @return: 
//
//********************************************
function RaiseWindow(id) {
	var windowdiv = document.getElementById(id);
	zi = __zIndex++;
	windowdiv.style.zIndex=zi;
}



//********************************************
// destruye una ventana creada con CreateWindow.
//--------------------------------------------
//
// @params:
//	id: id de la div contenedora de la ventana.
//
// @return: 
//
//********************************************
function DestroyWindow(id) {
	var abody = document.getElementsByTagName("body");
	var vExplorer = isExplorer();
	
	var div = null;
	if (abody.length>=1) div = abody[0];
	if (div!=null) {
		var windowdiv;
		
		windowdiv = document.getElementById(id+"_parent");
		
		if (windowdiv!=null) {
			purge(windowdiv);
			div.removeChild(windowdiv);
		}
		
		windowdiv = document.getElementById(id);
		if (windowdiv!=null) {
			purge(windowdiv);
			div.removeChild(windowdiv);
		}
		
		var windowbg = document.getElementById(id + "bg");
		if (windowbg!=null) {
			if(activeWindows==1 && navigator.appName == 'Microsoft Internet Explorer'){
				activeWindows=0;
			}
			purge(windowbg);
			div.removeChild(windowbg);
		}
		
		var windowiframe = document.getElementById(id + "_parent");
		if (windowiframe!=null) {
			purge(windowiframe);
			div.removeChild(windowiframe);
		}
		
	}
	//Manda el foco al ultimo foco conocido.
	setFocusOn(lastFocus);
	//Vuelve a mostrar los select que ocultamos en CreateWindow.
	if (vExplorer<=6 && vExplorer>3) {
		if (allSelects[id]) {
			len = allSelects[id].length;
			for (i=0;i<len;i++) {
				select = allSelects[id].pop();
				select.style.visibility='visible';
			}
			allSelects[id] = null;
		}
	}
}


//********************************************
// establece el estado de visibilidad de un elemento
// usando el id.
//--------------------------------------------
//
// @params:
//	id: id del elemento.
//	visible: true | false.
//
// @return: 
//
//********************************************
function Show(id,visible) {
	obj = document.getElementById(id);
	if (obj==null) return;
	if (visible) {
		obj.style.visibility = "visible";
	} else {
		obj.style.visibility = "hidden";
	}
	//Les pone la misma visibilidad que la capa que los contiene.
	vExplorer = isExplorer();
	if (vExplorer<=6 && vExplorer>3) {
		selects = obj.getElementsByTagName('select');
		for (i=0;i<selects.length;i++) selects[i].style.visibility =obj.style.visibility;
	}
}

function Display(id, visible){
  obj = document.getElementById(id);
  if (obj==null) return;
  if (visible) {
    obj.style.display = "";
  } else {
    obj.style.display = "none";
  }
}

function Resize(id,w,h) {
	obj = document.getElementById(id);
	if (obj==null) return;
	if (w>0) obj.style.width=w+ "px";
	if (h>0) obj.style.height=h+ "px";
}

function ShowAndResize(id,visible,w,h) {
	Show(id,visible);
	Resize(id,w,h);
}

function SwapShow(id) {
	obj = document.getElementById(id);
	if (obj==null) return;
	if (obj.style.visibility=="visible") {
		Show(id,false);
	} else {
		Show(id,true);
	}
}

//Pequeño workaround para devolver el foco despues de un popup 
//al ultimo objeto sobre el que hicimos un setFocus.
var lastFocus;

function setFocusOn(id) {
	obj = document.getElementById(id);
	if (obj==null) return;
  try { obj.focus(); } catch (e) {}
	lastFocus = id;
}





//********************************************
// limpia espacios al principio y al final
// de una cadena.
//--------------------------------------------
//
// @params:
//	str: la cadena a limpiar.
//
// @return: 
//	la cadena modificada.
//
//********************************************
function cleanSpaces(str) {
	//pendiente
}


function setFlashVar(flashid,varname,varvalue) {
	fl = document.getElementById("mz" + flashid);
	if (!fl) fl = document.getElementById(flashid);
 	if (fl!=null) fl.SetVariable(varname,varvalue);
}

function hasMiniumSize(minH){
    var height = screen.height, ratio = 1;
  // compute scaling between inner size and outer size in chrome 43
    if (typeof window.innerWidth == 'number') {
      var ratioW = window.outerWidth / window.innerWidth;
      var ratioH = window.outerHeight / window.innerHeight;
      ratio = Math.ceil(Math.min(ratioW, ratioH) * 10) / 10;
      height = height / ratio;
    }
    if (height < minH) {
      return "false";
    }
    return "true";
}

//var chatWindowStatus = 0;
//function setChatWindowStatus(status) {
//	chatWindowStatus = status;
////}

//var chatWindow = null;
//function openChat(para,roomid,solicitud) {
//	if (!chatWindow || chatWindow.closed) {
//		var chatparams = '';
//        var width = 712;
//        var height = 562;
//        var widtha = 728;
//        var heighta = 652;
//
//		if(para != '' ){
//			chatparams = '?para=' + para + '&roomid=' + roomid + '&solicitud=' + solicitud + '&hasminsize=' + hasMiniumSize(heighta);
//		} else {
//           chatparams = '?hasminsize=' + hasMiniumSize(heighta);
//        }
//		var url = "wmiscomchat.php" + chatparams;
//		//var url = "testresize.php" + chatparams;
//        if (hasMiniumSize(heighta) == "true")  {
//            chatWindow = window.open(url, 'chat', 'height='+heighta+',width='+widtha+',scrollbars=0,resizable=1,toolbar=yes');
//        } else {
//            chatWindow = window.open(url, 'chat', 'height='+height+',width='+width+',scrollbars=0,resizable=1,toolbar=no');
//        }
//		if(!chatWindow.opener) chatWindow.opener=self;
//		if(window.focus){
//			chatWindow.focus();
//		}
//	} else {
//		ajax_call("__","php/lanzachatprivado.php?para=" + para + "&solicitud=" + solicitud + "&roomid=" + roomid,null);
//        //if (isFirefox()) {
//        //    fh = document.getElementById('mzFlashHead');
//        //} else fh = document.getElementById('FlashHead');
//		//fh.openPrivateChat(para,roomid,solicitud);
//		//url = "php/lanzachatprivado.php?para=" + para + "&solicitud=" + solicitud + "&roomid=" + roomid;
//		//alert(url);
//		//ajax_call("__","php/lanzachatprivado.php?para=" + para + "&solicitud=" + solicitud + "&roomid=" + roomid,null);
//	}
//}
window.openChat = function(useridId) {
  window.mf = window.mf || [];
  window.mf.push({action:'OpenChatAction', userid: useridId});
};

function openChatFromFlash(para,roomid,solicitud) {
	window.opener.ajax_call("__","php/lanzachatprivado.php?para=" + para + "&solicitud=" + solicitud + "&roomid=" + roomid,null);
}


function reloadChat() {
	window.location.reload();
}

function showPopUp(windowname,url) {
	CreateURLWindow(windowname,
					0,
					0,
					url);
}

function setWindowToFullScreen(windowname) {
	wn = document.getElementById(windowname);
	wn.style.position='absolute';
	wn.style.left='0px';
	wn.style.top='0px';
	wn.style.width = getDocumentWidth() + "px";
	wn.style.height = getDocumentHeight() + "px";
	wn.style.width="100%";
	wn.style.height="100%";
}

function showInfoPopUp(title,msg) {
	CreateURLWindow("infowindow",
					getWindowWidth()/2-100,
					getWindowHeight()/2-100,
					"/php/mostrarpopupinfo.php?ttl=" + encodeURI(title) +
					"&msg=" + encodeURI(msg));
}

function showStaticInfoPopUp(title,msg, closeButtonText) {
    CreateStaticWindow("infowindow",
        getWindowWidth()/2-100,
        getWindowHeight()/2-100,
        title, msg, closeButtonText);
}

function showConfirmationPopUp(title,msg,yeslink,nolink) {
	CreateURLWindow("confirmationwindow",
					getWindowWidth()/2-100,
					getWindowHeight()/2-100,
					"php/mostrarpopupconfirmation.php?ttl=" + encodeURI(title) + 
					"&msg=" + encodeURI(msg) + "&ylink="+yeslink+"&nlink=" + nolink);
}

function showWarningPopUp(title,msg,onclose){
	CreateURLWindow("warningwindow",
					getWindowWidth()/2-175,
					getWindowHeight()/2-150,
					"php/mostrarpopupaviso.php?ttl=" + encodeURI(title) + 
					"&msg=" + encodeURI(msg) + "&onclose=" + onclose);
}

//********************************************
// Funcion para en los submenus verticales.
// Resalta el fondo del submenu donde este el cursor.
//--------------------------------------------
//
// @params:
//	H: elemento donde se ha situado el cursor.
//
//********************************************
function fhover(H){
if(H.className.indexOf("HoverBGColor")>=0)
H.className=H.className.replace("HoverBGColor ","");
else H.className="HoverBGColor "+H.className;
}

//********************************************
// Funciones de la primera version del portal.
// Funciones utilizadas para mostrar y ocultar textos con los links de "comprimir todo" y "expandir todo".
function activa(tipo)
{
	if (activado!="") document.getElementById(activado).style.display="none";
	if (activado!=tipo)
	{
		document.getElementById(tipo).style.display="";
		activado=tipo;
	}
	else activado="";
}

function activa_sub(tipo,enlace)
{
	if (document.getElementById(tipo).style.display=='none')
	{ 
		document.getElementById(tipo).style.display="";
		// muestra en la subseccion el link comprimir todo
		
		var splittedId = tipo.split("_");
		subid = splittedId[0] + "_" + splittedId[1] + "_" + splittedId[2];
		
		document.getElementById(subid).style.display="";
	}
	else 
	{
		document.getElementById(tipo).style.display="none";
		
		var splittedId = tipo.split("_");
		subid = splittedId[0] + "_" + splittedId[1] + "_" + splittedId[2];
		
		document.getElementById(subid).style.display="";
		subspans=document.getElementsByName(subid);
		subdisplay="none";
		for(i=0;i<subspans.length;i++)
		{
			if (subspans[i].style.display=="") subdisplay="";
		}
		document.getElementById(subid).style.display=subdisplay;
	}
	if (document.getElementById(enlace).className=='expandirbw') document.getElementById(enlace).className="comprimirbw";
		else document.getElementById(enlace).className="expandirbw";
}

function comprimir_todo(tipo,enlace)
{
	v_doc=document.getElementsByTagName('*');
	for(i=0;i<v_doc.length;i++)
	{
		tam=tipo.length;
		valor=v_doc[i].id.substring(0,tam);
		tam2=enlace.length;
		valor2=v_doc[i].id.substring(0,tam2);
		if (valor==tipo) v_doc[i].style.display="none";
		if (valor2==enlace) v_doc[i].className="expandirbw";
	}
}

function expandir_todo(tipo,enlace)
{
	v_doc=document.getElementsByTagName('*');
	for(i=0;i<v_doc.length;i++)
	{
		tam=tipo.length;
		valor=v_doc[i].id.substring(0,tam);
		tam2=enlace.length;
		valor2=v_doc[i].id.substring(0,tam2);
		if (valor==tipo) v_doc[i].style.display="";
		if (valor2==enlace) v_doc[i].className="comprimirbw";
	}
}

function ocultar(tipo)
{
	document.getElementById(tipo).style.display="none";
	activado="";
}

//Comprueba el formato del correo
function verifica_mail(t_mail)
{
	if ((t_mail.lastIndexOf(" ")!=-1) || (t_mail.lastIndexOf("@")==-1) || (t_mail.lastIndexOf(".")<=(t_mail.lastIndexOf("@")+1)) || (t_mail.lastIndexOf(".")==(t_mail.length-1))) return false;
		else return true;
}

var javascriptNewMessage = "";
function OnNewMessage() {
	eval(javascriptNewMessage);
}

var javascriptNewMobi = "";
function OnNewMobi() {
	eval(javascriptNewMobi);
}

function show_div(tipo)
{	
	if(document.getElementById(tipo)) document.getElementById(tipo).style.display="block";
}

function hide_div(tipo)
{
	if(document.getElementById(tipo)) document.getElementById(tipo).style.display="none";
}

function ifsetdisplay(divtipo,divboton)
{
	if (document.getElementById(divtipo).style.display=='none')
	{ 
		document.getElementById(divboton).style.display="block";
	}
	else 
	{	
		document.getElementById(divboton).style.display="none";
	}
}


function compareOptionText(a,b) {

	// textual comparison
	return a.text!=b.text ? a.text<b.text ? -1 : 1 : 0;

}

function sortOptions(list) {

	var items = list.options.length;

	// create array and make copies of options in list
	var tmpArray = new Array(items);

	for ( i=0; i<items; i++ )
		tmpArray[i] = new Option(list.options[i].text,list.options[i].value);

	// sort options using given function
	tmpArray.sort(compareOptionText);
	
	// make copies of sorted options back to list
	for ( i=0; i<items; i++ )
		list.options[i] = new Option(tmpArray[i].text,tmpArray[i].value);

}

function onCloseSession() {
	document.location='login.php';	
}

function sendVerificationEmail(email, userId){
	var response_container = document.getElementById('verification-email-sent');
	response_container.innerHTML = "<img src='https://sti.mfstat.net/common/popups/h-ajax-loading.gif' border='0' />";

  ajax_place_response("php/email_verify_email_address.php?email=" + email + "&userId=" + userId, null, response_container);
}

function externalLinks() {
	if (!document.getElementsByTagName) {
		return;
	}
	var anchors = document.getElementsByTagName("a");
	for (var i = 0; i < anchors.length; i++) {
		var anchor = anchors[i];
		if (anchor.getAttribute("rel")) {
			var rel = anchor.getAttribute("rel");
			var external = false;
			if (rel.indexOf(" ") > 0) {
				while (rel.indexOf(" ") > 0 && external == false) {
					if (rel.substr(0, rel.indexOf(" ")) == "external") {
						external = true;
					}
					rel = rel.substr(rel.indexOf(" ") + 1, rel.length - rel.indexOf(" ") + 1);
				}
			}
			if (rel == "external") {
				external = true;
			}
			if (anchor.getAttribute("href") && external == true) {
				anchor.target = "_blank";
			}
		}
	}
	return;
}

function textareaCharCounter2(sourceId, targetId, minChars){
	var source = document.getElementById(sourceId);
	var target = document.getElementById(targetId);
	
	target.innerHTML = source.value.length;
	
}
function iframeLoaded() {
  $(".close").trigger("click");
  location.reload();
}
window.openOfferwallCredits = function() {
  window.mf = window.mf || [];
  window.mf.push({
    action: 'OpenOfferwallCreditsModalAction',
  });
};

var propiedad_auxiliar = "Es para los ajustes css y js";


//********************************************
//
//	Copyright Mobifriends S.L. 2007
//	
//	programador: Javier Velasco Gonzalez	
//
//********************************************

var error_page;
var errors;
var errorPages;

errors = new Array();
errorPages = new Array();

var sLoadingMessage = "string" === typeof sLoadingMessageTranslated ? sLoadingMessageTranslated:"Loading...";
var bLoading = false;
var sLoadingOpacity = "80";

function  html_cargador() {
	/*
	var protocol = (("https:" == document.location.protocol) ? "https://" : "http://");
	return "<object classid='clsid:d27cdb6e-ae6d-11cf-96b8-444553540000' codebase='"+protocol+"fpdownload.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=			8,0,0,0' width='100%' height='32' align='middle'>" + 
			"<param name='allowScriptAccess' value='sameDomain' />"+
			"<param name='wmode' value='transparent' /><param name='movie' value='" + ajaxLoaderClip + "' />"+
			"<param name='quality' value='high' /><param name='scale' value='noscale' />"+
			"<embed src='" + ajaxLoaderClip + "' scale='noscale' quality='high' width='100%' height='32' " + 
			"align='middle' wmode='transparent' allowScriptAccess='sameDomain' " + 
   			"type='application/x-shockwave-flash' pluginspage='"+protocol+"www.adobe.com/go/getflashplayer' />" + 
			"</object>";
	*/
}

//********************************************
// hace una llamada remota a un script copiando 
// la respueta dentro del elemento id.
//--------------------------------------------
//
// @params:
//	id: attributo id del elemento que recibe la respueta.
//	url: url del script en el servidor.
//	func: funcion que recibe los errores, si se omite 
//		se hace una llamada a las funciones generales
//		para el tratamiento de errores (ver ajax_on_error).
//
// @return: 
//
//********************************************
function ajax_call(id,url, func,disableloader) {
	var request;
	var error_func = func;
	
	if(typeof XMLHttpRequest!='undefined') {
		request = new XMLHttpRequest();
	} else {
		if (Number(navigator.appVersion.substr(0,3))>=5) 
			request = new ActiveXObject('Msxml2.XMLHTTP');
		else
			request = new ActiveXObject('Microsoft.XMLHTTP');
	}

	if (request) {
		request.onreadystatechange = function () {
			if(request.readyState == 4)
			{
				if (request.status == 200) {
					if (!disableloader) {
						DestroyWindow("backgroundloader");
						DestroyWindow("ajaxloader");
					}
					element = document.getElementById(id);
					if (element!=null) element.innerHTML = request.responseText;
					/* ejecuta los scripts dentro del html */
					var startPos=0;
					var endPos=0;
					var script;
					var uchtml = request.responseText;
					startPos = 0;	
					do {
						startPos = uchtml.indexOf("<script",startPos);
						if (startPos<0) break;
						startPos = 1 + uchtml.indexOf(">",startPos);
						endPos = uchtml.indexOf("</script>",startPos);
						script =request.responseText.substr(startPos,endPos-startPos);

						if (window.execScript){
							window.execScript(script);
						}else{
							eval(script);
						}

						startPos = endPos+1;
					} while(true);
				} else {
				   if (error_func) {
				   		error_func(request.status);			   	
				   } else {
				   		for (var i in errors) {
        					if (errors[i]==request.status) {
        						//alert(errorPages[i]);
        						document.location = errorPages[i];
        					}
			   			}
				   }
				}
			} else { 
				DestroyWindow("backgroundloader");
				DestroyWindow("ajaxloader");
			}
		}
		if (!disableloader) {
			var wwidth = getWindowWidth();
			var wheight = getWindowHeight();
			CreateWindow("backgroundloader","0px","0px",wwidth + "px",wheight + "px","<br><br><br>",null,"30","loading-window2");
			CreateWindow("ajaxloader","0px","0px",wwidth + "px","32px",'Loading	',null,'80',"loading-window");		
		}
		request.open("GET",url,true)
		request.send(null);
	}
}


//********************************************
// envia el contenido de un form copiando 
// la respueta dentro del elemento id.
//--------------------------------------------
//
// @params:
//	id: attributo id del elemento que recibe la respuesta.
//	url: url del script en el servidor.
//	func: funcion que recibe los errores, si se omite 
//		se hace una llamada a las funciones generales
//		para el tratamiento de errores (ver ajax_on_error).
//
// @return: 
//
//********************************************
function ajax_submit_form(id,formName,url, func) {
	var request;
	var form;
	var formdata="";
	var fields;
	var error_func = func;
	
	form = document.getElementById(formName);
	if(typeof XMLHttpRequest!='undefined') {
		request = new XMLHttpRequest();
		fields = form.elements;
	} else {
		version = isExplorer();
		if (version>=5) 
			request = new ActiveXObject('Msxml2.XMLHTTP');
		else
			request = new ActiveXObject('Microsoft.XMLHTTP');
		if (version>=5 && version<7) fields = form.all;

	}
	
	for (i in fields)
	{
		var element = fields[i];
		if (element!=null && element.tagName!=null) {
			if (element.tagName=="SELECT" || element.tagName=="INPUT" || element.tagName=="TEXTAREA") {
				if (element.type=="checkbox" || element.type=="radio") {
					if (element.checked==true) {
						formdata+=element.name + "=" + element.value + "&";
					}
				} else {
					formdata+=element.name + "=" + encodeURIComponent(element.value) + "&";
				}
			}
		}
	}
	
	if (request) {
		request.onreadystatechange = function () {
			if(request.readyState == 4)
			{
				if (request.status == 200) {
					
					if(bLoading){
						DestroyWindow("backgroundloader");
						DestroyWindow("ajaxloader");
					}
					
					element = document.getElementById(id);
					//Si pusieramos cuidado en no borrar divs no tendria que hacer esto.
					if (element) element.innerHTML = request.responseText;
					/* ejecuta los scripts dentro del html */
					var startPos=0;
					var endPos=0;
					var script;
					var uchtml = request.responseText.toUpperCase();
					startPos = 0;	



					/*
					do {
						startPos = uchtml.indexOf("<SCRIPT",startPos);
						if (startPos<0) break;
						startPos = 1 + uchtml.indexOf(">",startPos);
						endPos = uchtml.indexOf("</SCRIPT>",startPos);
						script =request.responseText.substr(startPos,endPos-startPos);
						if (window.execScript){
							window.execScript(script);
						}else{
							eval(script);
						}
						startPos = endPos+1;
					} while(true);
					*/

					do {

				    startPos = uchtml.indexOf("<SCRIPT", startPos);
				    if (startPos < 0) break; // Sale del bucle si no encuentra más etiquetas <script>

				    startPos = 1 + uchtml.indexOf(">", startPos);
				    endPos = uchtml.indexOf("</SCRIPT>", startPos);

				    if (endPos < 0) {
				        // Si no encuentra una etiqueta de cierre </script>, sale del bucle
				        break;
				    }

				    script = request.responseText.substring(startPos, endPos);
				    
				    $('body').prepend("<script>"+script+"</script>");
				    
				    //if (window.execScript) {
				        //window.execScript(script);
				    //} else {
				        //eval(script);
				    //}

				    startPos = endPos + 9; // Actualiza startPos al final de la etiqueta </script>
				} while (true);

				} else {
				   if (error_func) {
				   		error_func(request.status);			   	
				   } else {
				   		for (var i in errors) {
        					if (errors[i]==request.status) {
        						//alert(errorPages[i]);
        						document.location = errorPages[i];
        					}
			   			}
				   }
				}
			}
		}

		if(bLoading){
			var wwidth = getWindowWidth();
			var wheight = getWindowHeight();
			CreateWindow("backgroundloader","0px","0px",wwidth + "px",wheight + "px","",null,"30");
			CreateWindow("ajaxloader","0px","0px",wwidth + "px","32px",sLoadingMessage,null,sLoadingOpacity,"loading-window");
		}
			
		request.open("POST",url,true)
		request.setRequestHeader("Content-Type","application/x-www-form-urlencoded");
		request.send(formdata);
	}
}


// ********************************************
// exactly the same as ajax_submit_form, but it expects a JSON response
function ajax_submit_form_json(id,formName,url, func) {
	var form;
	var formdata="";
	var error_func = func;

	form = document.getElementById(formName);
	var request = new XMLHttpRequest();
	var fields = form.elements;

	for (i in fields)
	{
		var element = fields[i];
		if (element!=null && element.tagName!=null) {
			if (element.tagName=="SELECT" || element.tagName=="INPUT" || element.tagName=="TEXTAREA") {
				if (element.type=="checkbox" || element.type=="radio") {
					if (element.checked==true) {
						formdata+=element.name + "=" + element.value + "&";
					}
				} else {
					formdata+=element.name + "=" + encodeURIComponent(element.value) + "&";
				}
			}
		}
	}

	if (request) {
		request.onreadystatechange = function () {
			if(request.readyState == 4)
			{
				if (request.status == 200) {

					if(bLoading){
						DestroyWindow("backgroundloader");
						DestroyWindow("ajaxloader");
					}

					try {
						const data = JSON.parse(request.responseText);
						console.log("JSON response", data);
						if(data.redirect) {
							window.location.href = data.redirect + '?' + new Date().getTime();
						}
					} catch (e) {
						console.log("Error parsing JSON response", e);
					}
				} else {
					if (error_func) {
						error_func(request.status);
					} else {
						for (var i in errors) {
							if (errors[i]==request.status) {
								document.location = errorPages[i];
							}
						}
					}
				}
			}
		}

		if(bLoading){
			var wwidth = getWindowWidth();
			var wheight = getWindowHeight();
			CreateWindow("backgroundloader","0px","0px",wwidth + "px",wheight + "px","",null,"30");
			CreateWindow("ajaxloader","0px","0px",wwidth + "px","32px",sLoadingMessage,null,sLoadingOpacity,"loading-window");
		}

		request.open("POST",url,true)
		request.setRequestHeader("Content-Type","application/x-www-form-urlencoded");
		request.send(formdata);
	}
}


//********************************************
// llama al ajax_submit_form, cuando el usuario 
// aprieta el Enter
//--------------------------------------------
//
// @params: (el evento y los parametros de ajax_submit_form)
//
// @return: 
//
//********************************************
function ienter_submit_form(evento, id,formName,url, func) {
	var iAscii;
	if (evento.keyCode) iAscii = evento.keyCode; 
		else if (evento.which) iAscii = evento.which; 
			else return false; 
	if (iAscii == 13) ajax_submit_form(id,formName,url, func); 
	return true; 
}


//********************************************
// envia el contenido de un form copiando 
// ejecutando la respueta como un script.
//--------------------------------------------
//
// @params:
//	formName: id del formulario.
//	url: url del script en el servidor.
//	func: funcion que recibe los errores, si se omite 
//		se hace una llamada a las funciones generales
//		para el tratamiento de errores (ver ajax_on_error).
//
// @return: 
//
//********************************************
function ajax_eval_form(formName,url, func,disableloader) {
	var request;
	var form;
	var formdata="";
	var fields;
	var error_func = func;
	var scrWidth,scrHeight;
	
	form = document.getElementById(formName);
	if (form==null) return;
	fields = form.elements;
	if(typeof XMLHttpRequest!='undefined') {
		request = new XMLHttpRequest();
	} else {
		version = isExplorer();
		if (version>=5) 
			request = new ActiveXObject('Msxml2.XMLHTTP');
		else
			request = new ActiveXObject('Microsoft.XMLHTTP');
		if (version>=5 && version<7) fields = form.all;
		
	}

	for (i in fields)
	{
		var element = fields[i];
		if (element!=null && element.tagName!=null) {
			if (element.tagName=="SELECT" || element.tagName=="INPUT" || element.tagName=="TEXTAREA") {
				if (element.type=="checkbox" || element.type=="radio" ) {
					if (element.checked==true) {
						formdata+=element.name + "=" + element.value + "&";
					}
				} else {
					formdata+=element.name + "=" + encodeURIComponent(element.value) + "&";
				}
			}
		}
	}
	
	if (request) {
		request.onreadystatechange = function () {
			if(request.readyState == 4)
			{
				if (request.status == 200) {
					if (window.execScript){
						window.execScript(request.responseText);
					}else{
						eval(request.responseText);
					}
				} else {
				   if (error_func) {
				   		error_func(request.status);			   	
				   } else {
				   		for (var i in errors) {
        					if (errors[i]==request.status) {
        						//alert(errorPages[i]);
        						document.location = errorPages[i];
        					}
			   			}
				   }
				}
			}
		}
		request.open("POST",url,true);
		request.setRequestHeader("Content-Type","application/x-www-form-urlencoded; charset=utf-8");
		request.send(formdata);
	}
}

function jq_ajax_eval_form(formName,url, func,disableloader) {
  var request;
  var form;
  var formdata="";
  var fields;
  var error_func = func;

  form = document.getElementById(formName);
  if (form==null) return;
  fields = form.elements;
  if(typeof XMLHttpRequest!='undefined') {
    request = new XMLHttpRequest();
  } else {
    version = isExplorer();
    if (version>=5)
      request = new ActiveXObject('Msxml2.XMLHTTP');
    else
      request = new ActiveXObject('Microsoft.XMLHTTP');
    if (version>=5 && version<7) fields = form.all;

  }
  formdata = $("#" + formName).serialize();
  if (request) {
    request.onreadystatechange = function () {
      if(request.readyState == 4)
      {
        if (request.status == 200) {
          if (!disableloader) {
            var userAgent = navigator.userAgent;
            if (userAgent.indexOf("MSIE 9") !== -1) {}
          }
          if (window.execScript){
            window.execScript(request.responseText);
          }else{
            eval(request.responseText);
          }
        } else {
          if (error_func) {
            error_func(request.status);
          } else {
            for (var i in errors) {
              if (errors[i]==request.status) {
                //alert(errorPages[i]);
                document.location = errorPages[i];
              }
            }
          }
        }
      }
    }

    if (!disableloader) {
      var userAgent = navigator.userAgent;
      if (userAgent.indexOf("MSIE 9") !== -1) {}
      else {
      }
    }
    request.open("POST",url,true);
    request.setRequestHeader("Content-Type","application/x-www-form-urlencoded; charset=utf-8");
    request.send(formdata);
  }
}

//********************************************
// añade una funcion envia el contenido de un form copiando 
// la respueta dentro del elemento id.
//--------------------------------------------
//
// @params:
//	id: attributo id del elemento que recibe la respuesta.
//	url: url del script en el servidor.
//	func: funcion que recibe los errores, si se omite 
//		se hace una llamada a las funciones generales
//		para el tratamiento de errores (ver ajax_on_error).
//
// @return: 
//
//********************************************
function ajax_on_error(status,url) {
	errors.push(status);
	errorPages.push(url);
}

//********************************************
// registra una pelicula para ser mostrada 
// mientras se esperan datos en una peticion AJAX.
//--------------------------------------------
//
// @params:
//	clipname: nombre del movieclip de flash.
//
// @return: 
//
//********************************************
function ajax_register_loader(clipname) {
	// ajaxLoaderClip = clipname;
	bLoading = true;
}

function ajax_eval_response(url, params) {
	var request;
	var version;

	if(typeof XMLHttpRequest!='undefined') {
		request = new XMLHttpRequest();
	} else {
		version = isExplorer();
		if (version>=5) 
			request = new ActiveXObject('Msxml2.XMLHTTP');
		else
			request = new ActiveXObject('Microsoft.XMLHTTP');		
	}
	
	if (request) {
		request.onreadystatechange = function () {
			if(request.readyState == 4){
				if (request.status == 200) {
					if (window.execScript){
						window.execScript(request.responseText);
					}else{
						eval(request.responseText);
					}
				}
			}
		}
		
		request.open("POST",url,true);
		request.send(params);
	}
}

function ajax_place_response(url, params, place) {
  var request;
  var version;

  if(typeof XMLHttpRequest!='undefined') {
    request = new XMLHttpRequest();
  } else {
    version = isExplorer();
    if (version>=5)
      request = new ActiveXObject('Msxml2.XMLHTTP');
    else
      request = new ActiveXObject('Microsoft.XMLHTTP');
  }

  if (request) {
    request.onreadystatechange = function () {
      if(request.readyState == 4){
        if (request.status == 200) {
          if (window.execScript){
            window.execScript(request.responseText);
          }else{
            place.innerHTML = request.responseText;
          }
        }
      }
    }

    request.open("GET",url,true);
    request.send(params);
  }
}


//********************************************
// Versión 2 de la funcion ajax_submit_form
// envia el contenido de un form copiando 
// la respueta dentro del elemento id.
// en el caso de que de error, la respuesta será enviada a 
// una capa llamada error_box.
//********************************************
function messages_ajax_submit_form2(id,formName,url, func) {
	const paraInput = document.getElementById('para');
	if (paraInput && paraInput.value.trim() === '') {
		dialogConfirm('Atención','Tienes que poner un destinatario al mensaje');
		return;
	}
	const asuntinput = document.getElementById('asuntinput');
	if (asuntinput && asuntinput.value.trim() === '') {
		dialogConfirm('Atención','Tienes que poner el asunto del mensaje');
		return;
	}
	const mens_txta = document.getElementById('mens_txta');
	if (mens_txta && mens_txta.value.trim() === '') {
		dialogConfirm('Atención','Tienes que poner algo en el mensaje');
		return;
	}
	ajax_submit_form2(id,formName,url, func);
}
function ajax_submit_form2(id,formName,url, func) {
	var request;
	var form;
	var formdata="";
	var fields;
	var error_func = func;
	
	form = document.getElementById(formName);
	if(typeof XMLHttpRequest!='undefined') {
		request = new XMLHttpRequest();
		fields = form.elements;
	} else {
		version = isExplorer();
		if (version>=5) 
			request = new ActiveXObject('Msxml2.XMLHTTP');
		else
			request = new ActiveXObject('Microsoft.XMLHTTP');
		if (version>=5 && version<7) fields = form.all;

	}
	
	for (i in fields)
	{
		var element = fields[i];
		if (element!=null && element.tagName!=null) {
			if (element.tagName=="SELECT" || element.tagName=="INPUT" || element.tagName=="TEXTAREA") {
				if (element.type=="checkbox" || element.type=="radio") {
					if (element.checked==true) {
						formdata+=element.name + "=" + element.value + "&";
					}
				} else {
					formdata+=element.name + "=" + encodeURIComponent(element.value) + "&";
				}
			}
		}
	}
	
	if (request) {
		request.onreadystatechange = function () {
			if(request.readyState == 4)
			{
				if (document.getElementById('disable-button')) {
					document.getElementById('disable-button').disabled = false;
				}
				if (request.status == 200) {
					
					if(bLoading){
						DestroyWindow("backgroundloader");
						DestroyWindow("ajaxloader");
					}
					
					element = document.getElementById(id);
					//Si pusieramos cuidado en no borrar divs no tendria que hacer esto.
					if (element) element.innerHTML = request.responseText;
					/* ejecuta los scripts dentro del html */
					var startPos=0;
					var endPos=0;
					var script;
					var uchtml = request.responseText;
					startPos = 0;	
					do {
						startPos = uchtml.indexOf("<script",startPos);
						if (startPos<0) break;
						startPos = 1 + uchtml.indexOf(">",startPos);
						endPos = uchtml.indexOf("</script>",startPos);
						script =request.responseText.substr(startPos,endPos-startPos);
						if (window.execScript){
							window.execScript(script);
						}else{
							eval(script);
						}
						startPos = endPos+1;
					} while(true);	
				} else {
					if(bLoading){
						DestroyWindow("backgroundloader");
						DestroyWindow("ajaxloader");
					}
					document.getElementById('error_box').innerHTML = request.responseText;
					/* ejecuta los scripts dentro del html */
					var startPos=0;
					var endPos=0;
					var script;
					var uchtml = request.responseText.toUpperCase();
					startPos = 0;	
					do {
						startPos = uchtml.indexOf("<SCRIPT",startPos);
						if (startPos<0) break;
						startPos = 1 + uchtml.indexOf(">",startPos);
						endPos = uchtml.indexOf("</SCRIPT>",startPos);
						script =request.responseText.substr(startPos,endPos-startPos);
						if (window.execScript){
							window.execScript(script);
						}else{
							eval(script);
						}
						startPos = endPos+1;
					} while(true);						
				}
			}
		}

		if(bLoading){
			var wwidth = getWindowWidth();
			var wheight = getWindowHeight();
			CreateWindow("backgroundloader","0px","0px",wwidth + "px",wheight + "px","<br><br><br>",null,"30","loading-window2");
			CreateWindow("ajaxloader","0px","0px",wwidth + "px","32px",'Loading	',null,'80',"loading-window");		
		}

		if (document.getElementById('disable-button')) {
			document.getElementById('disable-button').disabled = true;
		}
		request.open("POST",url,true)
		request.setRequestHeader("Content-Type","application/x-www-form-urlencoded");
		request.send(formdata);
	}
}

var END_OF_INPUT = -1;
var base64Str;
var base64Count;
var base64Chars = new Array(
    'A','B','C','D','E','F','G','H',
    'I','J','K','L','M','N','O','P',
    'Q','R','S','T','U','V','W','X',
    'Y','Z','a','b','c','d','e','f',
    'g','h','i','j','k','l','m','n',
    'o','p','q','r','s','t','u','v',
    'w','x','y','z','0','1','2','3',
    '4','5','6','7','8','9','+','/'
);
 
var reverseBase64Chars = new Array();
for (var i=0; i < base64Chars.length; i++){
    reverseBase64Chars[base64Chars[i]] = i;
}
function setBase64Str(str){base64Str = str;base64Count = 0;}
function readBase64(){    
    if (!base64Str) return END_OF_INPUT;
    if (base64Count >= base64Str.length) return END_OF_INPUT;
    var c = base64Str.charCodeAt(base64Count) & 0xff;
    base64Count++;
    return c;
}
function encodeBase64(str){
    setBase64Str(str);
    var result = '';
    var inBuffer = new Array(3);
    var lineCount = 0;
    var done = false;
    while (!done && (inBuffer[0] = readBase64()) != END_OF_INPUT){
        inBuffer[1] = readBase64();
        inBuffer[2] = readBase64();
        result += (base64Chars[ inBuffer[0] >> 2 ]);
        if (inBuffer[1] != END_OF_INPUT){
            result += (base64Chars [(( inBuffer[0] << 4 ) & 0x30) | (inBuffer[1] >> 4) ]);
            if (inBuffer[2] != END_OF_INPUT){
                result += (base64Chars [((inBuffer[1] << 2) & 0x3c) | (inBuffer[2] >> 6) ]);
                result += (base64Chars [inBuffer[2] & 0x3F]);
            } else {
                result += (base64Chars [((inBuffer[1] << 2) & 0x3c)]);
                result += ('=');
                done = true;
            }
        } else {
            result += (base64Chars [(( inBuffer[0] << 4 ) & 0x30)]);
            result += ('=');
            result += ('=');
            done = true;
        }
        lineCount += 4;
        if (lineCount >= 76){
            result += ('\n');
            lineCount = 0;
        }
    }
    return result;
}

// Base64 encoder/decoder with UTF-8 support
//
// Copyright (c) 2011 Vitaly Puzrin
// Copyright (c) 2011 Aleksey V Zapparov
//
// Author: Aleksey V Zapparov AKA ixti (http://www.ixti.net/)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.


// Based on original artworks of base64 encoder/decoder by [Mozilla][1]
// [1]: http://lxr.mozilla.org/mozilla/source/extensions/xml-rpc/src/nsXmlRpcClient.js


(function (global) {
  'use strict';

  var log = function () {},
    padding = '=',
    chrTable = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz' +
      '0123456789+/',
    binTable = [
      -1,-1,-1,-1, -1,-1,-1,-1, -1,-1,-1,-1, -1,-1,-1,-1,
      -1,-1,-1,-1, -1,-1,-1,-1, -1,-1,-1,-1, -1,-1,-1,-1,
      -1,-1,-1,-1, -1,-1,-1,-1, -1,-1,-1,62, -1,-1,-1,63,
      52,53,54,55, 56,57,58,59, 60,61,-1,-1, -1, 0,-1,-1,
      -1, 0, 1, 2,  3, 4, 5, 6,  7, 8, 9,10, 11,12,13,14,
      15,16,17,18, 19,20,21,22, 23,24,25,-1, -1,-1,-1,-1,
      -1,26,27,28, 29,30,31,32, 33,34,35,36, 37,38,39,40,
      41,42,43,44, 45,46,47,48, 49,50,51,-1, -1,-1,-1,-1
    ];

  if (global.console && global.console.log) {
    log = function (message) {
      global.console.log(message);
    };
  }

  // internal helpers //////////////////////////////////////////////////////////

  function utf8Encode(str) {
    var bytes = [], offset = 0, length, char;

    str = encodeURI(str);
    length = str.length;

    while (offset < length) {
      char = str[offset];
      offset += 1;

      if ('%' !== char) {
        bytes.push(char.charCodeAt(0));
      } else {
        char = str[offset] + str[offset + 1];
        bytes.push(parseInt(char, 16));
        offset += 2;
      }
    }

    return bytes;
  }

  function utf8Decode(bytes) {
    var chars = [], offset = 0, length = bytes.length, c, c2, c3;

    while (offset < length) {
      c = bytes[offset];
      c2 = bytes[offset + 1];
      c3 = bytes[offset + 2];

      if (128 > c) {
        chars.push(String.fromCharCode(c));
        offset += 1;
      } else if (191 < c && c < 224) {
        chars.push(String.fromCharCode(((c & 31) << 6) | (c2 & 63)));
        offset += 2;
      } else {
        chars.push(String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)));
        offset += 3;
      }
    }

    return chars.join('');
  }

  // public api ////////////////////////////////////////////////////////////////

  function encode(str) {
    var result = '',
      bytes = utf8Encode(str),
      length = bytes.length,
      i;

    // Convert every three bytes to 4 ascii characters.
    for (i = 0; i < (length - 2); i += 3) {
      result += chrTable[bytes[i] >> 2];
      result += chrTable[((bytes[i] & 0x03) << 4) + (bytes[i+1] >> 4)];
      result += chrTable[((bytes[i+1] & 0x0f) << 2) + (bytes[i+2] >> 6)];
      result += chrTable[bytes[i+2] & 0x3f];
    }

    // Convert the remaining 1 or 2 bytes, pad out to 4 characters.
    if (length%3) {
      i = length - (length%3);
      result += chrTable[bytes[i] >> 2];
      if ((length%3) === 2) {
        result += chrTable[((bytes[i] & 0x03) << 4) + (bytes[i+1] >> 4)];
        result += chrTable[(bytes[i+1] & 0x0f) << 2];
        result += padding;
      } else {
        result += chrTable[(bytes[i] & 0x03) << 4];
        result += padding + padding;
      }
    }

    return result;
  }

  function decode(data) {
    var value, code, idx = 0,
      bytes = [],
      leftbits = 0, // number of bits decoded, but yet to be appended
      leftdata = 0; // bits decoded, but yet to be appended

    // Convert one by one.
    for (idx = 0; idx < data.length; idx++) {
      code = data.charCodeAt(idx);
      value = binTable[code & 0x7F];

      if (-1 === value) {
        // Skip illegal characters and whitespace
        log("WARN: Illegal characters (code=" + code + ") in position " + idx);
      } else {
        // Collect data into leftdata, update bitcount
        leftdata = (leftdata << 6) | value;
        leftbits += 6;

        // If we have 8 or more bits, append 8 bits to the result
        if (leftbits >= 8) {
          leftbits -= 8;
          // Append if not padding.
          if (padding !== data.charAt(idx)) {
            bytes.push((leftdata >> leftbits) & 0xFF);
          }
          leftdata &= (1 << leftbits) - 1;
        }
      }
    }

    // If there are any bits left, the base64 string was corrupted
    if (leftbits) {
      log("ERROR: Corrupted base64 string");
      return null;
    }

    return utf8Decode(bytes);
  }

  global.base64 = {encode: encode, decode: decode};
}(window));


////////////////////////////////////////////////////////////////////////////////
// vim:ts=2:sw=2
////////////////////////////////////////////////////////////////////////////////


function goenc() {
    //fix browser put user and password
    var seed = "#mbfrs";
    var password = document.getElementById('password').value;
    if (password.indexOf(seed) == -1 && password != ""){
        password = base64.encode(password) + seed;
    }
	document.getElementById('password').value = password;
	document.getElementById('usuarios_form').action='/checklogin.php';
//	document.getElementById('botonEnviar').style.display = 'none';
  if (document.getElementById('loginSpinner')) {
	  document.getElementById('loginSpinner').style.display = 'inline-block';
	  document.getElementById('enterValue').style.display = 'none';
  }
	document.getElementById('usuarios_form').submit();
}

function capLock(e){
	kc=e.keyCode?e.keyCode:e.which;
	sk=e.shiftKey?e.shiftKey:((kc==16)?true:false);
	if (kc>=65&&kc<=90) {
		document.getElementById('errorMays').value= '1';
	}
	else if(kc>=97&&kc<=122) {document.getElementById('errorMays').value = '0';}
}

$(document).ready(function(){
  var display = false;
  $("#registerTopButton").click(function(){
    $("#homepageForm").toggle(display);
    $(".registerText").toggle(display);
    $("#altadatosbasicosForm").toggle(!display);
    $("#enterText").toggle(!display);
    display = !display;
  });
});

 if (!signupForm) {
    var signupForm = 'altadatosbasicos';

 }
  $('#getProvinces').click(function(e) {
    ajax_submit_form2('provincia_div', signupForm,'/php/signup_form.php?cmd=leerprovincias',null);
    e.preventDefault();
  });
  $("#provincia_div").change(function() {
    var $province = $("#provincia_div option:selected").val();
    if ($province) {
        ajax_eval_form(signupForm,'/php/signup_form.php?cmd=leerlocalidad',null);
    } else {
      $("#localidad_div").html('');
      $("#provinceId").val('');
      $("#cityId").val('');
      $("#city").val('');
    }
 });
  $("#localidad_div").change(function() {
    var $city = $("#localidad_div option:selected").val();
    if ($city) {
        var $city_text = $("#localidad_div option:selected").text();
        var $province = $("#provincia_div option:selected").val();
        var $province_text = $("#provincia_div option:selected").text();
        $("#cityId").val($city);
        $("#provinceId").val($province);
        // add the text of the city+province and validate the field
        $("#city").val($city_text + " (" + $province_text + ")").trigger("blur");
    } else {
        $("#city").val('');
    }
  });
  $("#cityId").change(function() {
    $("#provincia_div").html('');
    $("#localidad_div").html('');
  });

var propiedad_auxiliar = "Es para los ajustes css y js";


function fillControlField() {
	ajax_eval_form('altadatosbasicos', 'php/signup_form.php?cmd=fillControlField',null);
}

$(document).ready(function() {

	fillControlField();

 
var validator = $("#altadatosbasicos").validate({
  errorElement: "div",
  errorClass: "validation-failed",
  validClass: "validation-passed",
  ignore: "",
  rules: {
      email: {
          email: true,
          remote: {
              url: "/php/signup_form.php?cmd=emailjson",
              dataType: "json",
              dataFilter: function(response) {
                  var jsonResponse = JSON.parse(response);
                  if (jsonResponse && jsonResponse.valid === false) {
                      return "\"" + invalidEmail + "\"";
                  } else if (jsonResponse && jsonResponse.inUse === true) {
                      return "\"" + emailInUse + "\"";
                  }
                  return "true";
              },

              data: {
                  email: function () {
                      return $("#email").val();
                  }
              }
          }
      },
      alias: {
          //alpha: true,
          remote: {
              url: "/php/signup_form.php?cmd=aliasjson",
              dataType: "jsonp",
              data: {
                  alias: function () {
                      return $("#alias").val();
                  }
              }
          }
      },
      "para_pb[]": {
          required: true
      },
      cityId: {
          required: true
      },
      busco_pb: {
          required: true
      }
  },
  
  messages: {
      alias: {
          required: requiredText,
          minlength: aliasMinMaxLength,
          maxlength: aliasMinMaxLength,
          alpha: aliasFormat,
          remote: aliasFormat
      },
      passwd: {
          required: requiredText,
          minlength: pwdMinLength
      },
      email: {
          required: requiredText,
          email: invalidEmail,
          remote: function() {
              return {
                  invalidEmail: invalidEmail,
                  emailInUse: emailInUse
              }[$.validator.format("{0}")];
          }
      },
      city: {
          required: requiredText
      },
      cityId: {
          required: requiredCity
      },
      confirmation: {
          required: requiredText
      },
      soy_pb: {
          required: requiredText
      },
      dia: {
          required: requiredBirthday
      },
      mes: {
          required: requiredBirthday
      },
      agno: {
          required: requiredBirthday
      },
      MyRule: {
          required: requiredBirthday
      }
  },
  submitHandler: function (e) {
      var data = $("#altadatosbasicos").serializeArray();
      $.ajax({
          url: '/php/signup_form.php',
          type: "POST",
          data: data,
          success: function (data) {
              if (data === "200") {
                $("#altadatosbasicosForm").hide();
                $("#altadatosbasicos2").show();
                return;
              }
              eval(data);
          }
      });
  }
});

// since the soy field name is dynamic, set the required by a new Class
$.validator.addMethod("cRequired", $.validator.methods.required, requiredText);
$.validator.addClassRules("soyRequired",{cRequired: true});

$('#submitForm').click(function (e) {
  e.preventDefault();
  $("#altabutton").trigger("click");
  return;
});
//validate the city hidden field
$("#city").blur(function() {
  var ret = validator.element("#cityId");
  if (!ret) {
    $(this).addClass("validation-failed").removeClass("validation-passed");
  }
});


});


var propiedad_auxiliar = "Es para los ajustes css y js";


var validator2 = $("#altadatos2").validate({
  errorElement: "div",
  errorClass: "validation-failed",
  validClass: "validation-passed",
  ignore: "",
  rules: {
    "to[]": {
      required: true
    },
    seek: {
      required: true
    }
  },
  messages: {
    confirmation: {
      required: requiredCertifico
    },
    seek: {
      required: requiredText
    },
    "to[]": {
      required: requiredPara
    },
    city: {
      required: requiredText
    },
    cityId: {
      required: requiredCity
    }
  },
  submitHandler: function (e) {
    var data = $("#altadatos2").serializeArray();
    $.ajax({
      url: '/php/signup_form_part2.php',
      type: "POST",
      data: data,
      success: function (data) {
        var info = JSON.parse(data);
        console.log(info);
        if (info.status.errorCode === 0) {
          // Preservar UTM params de la URL actual para GA4
          var currentParams = new URLSearchParams(window.location.search);
          var redirectUrl = '/web/signup/photo/';
          var utmParams = new URLSearchParams();
          if (currentParams.get('utm_source')) utmParams.append('utm_source', currentParams.get('utm_source'));
          if (currentParams.get('utm_medium')) utmParams.append('utm_medium', currentParams.get('utm_medium'));
          if (currentParams.get('utm_campaign')) utmParams.append('utm_campaign', currentParams.get('utm_campaign'));
          if (utmParams.toString()) {
            redirectUrl += '?' + utmParams.toString();
          }
          window.location = redirectUrl;
          return;
        }
      }
    });
  }
});
function __highlight(s, t) {
  if ($.ui.autocomplete) {
    var matcher = new RegExp("(" + $.ui.autocomplete.escapeRegex(t) + ")", "ig");
  }
  return s.replace(matcher, "<strong>$1</strong>");
}
$("#city").autocomplete({
  source : function(request, response) {
    $.ajax({
      url: "/php/cities_suggest.php",
      dataType : 'json',
      data : {
        term : request.term
      },
      success : function(data) {
        $("#cityId").val('');
        $("#provinceId").val('');
        $("#countryId").val('');
        response($.map(data, function(item) {
          return {
            label : __highlight(item.label,
              request.term),
            value : item.label,
            id: item.id,
            provinceId: item.provinceId,
            countryId: item.countryId
          };
        }));
      }
    });
  },
  minLength : 2,
  select : function(event, ui) {
    $("#cityId").val(ui.item.id).trigger("change");
    $("#provinceId").val(ui.item.provinceId);
    $("#countryId").val(ui.item.countryId);
  }
}).data("autocomplete")._renderItem = function(ul, item) {

  return $("<li></li>").data("item.autocomplete", item).append(
    $("<a></a>").html(item.label)).appendTo(ul);
};

$('#myDropdown').on('shown.bs.dropdown', function () {
  $("#user").focus();
})
function enviaform() {
  var valores_string=$("#buscaenmf_form").serialize();
  $.post('php/index_form.php?cmd=buscarForm', {
    valores:valores_string
  }, function(data) {
    if (data=="OK") {
      if (!peopleUrl) peopleUrl = "/personas";
      document.location=peopleUrl;
    }
  });
}
function func_onblur($valuelenght,$idfield, text) {
  var list = ['hotmai.com','hoitmail.com','hotmal.com','hotmali.com','hotmail.com.com','hotmailmail.com','hotmaill.com','hotmsil.com','hotmill.com','hothmail.com','hotmait.com','hitmail.com','hotmaul.com','holtmail.com','hotmaol.com','hotmaim.com'];
  if($valuelenght > 0) {
    if (text) {
      var textSplit = text.split('@');
      if (textSplit[1]) {
        var search = textSplit[1];
        if (jQuery.inArray(search, list) != -1) {
          $("#emailAlert").fadeIn();
        } else {
          $("#emailAlert").hide();
        }

      }
    }
    sendGA4Event('form_signup', 'completed', $idfield);
  }
  else {
    sendGA4Event('form_signup', 'skipped', $(this).attr('name'));
  }
}
function hideThis() {
  $("#emailAlert").hide();
}
function updateEmail(){
  var $email = $("#email");
  var emailSplit = $email.val().split('@');
  $email.val(emailSplit[0] + "@hotmail.com");
  hideThis();
}
$(function() {
  $(".close-banner").click(function(){
    $("#app-banner").hide();
  });
});


var propiedad_auxiliar = "Es para los ajustes css y js";


    var tokenId;
    // This is called with the results from from FB.getLoginStatus().
    function statusChangeCallback(response) {
        if (response.status === 'connected') {
            tokenId = response.authResponse.accessToken;
            doLogin();
        //} else if (response.status === 'not_authorized') {
        }
    }

    // This function is called when someone finishes with the Login
    // Button.  See the onlogin handler attached to it in the sample
    // code below.
    function checkLoginState() {
        FB.getLoginStatus(function(response) {
            statusChangeCallback(response);
        });
    }

    window.fbAsyncInit = function() {
        FB.init({
            appId      : fcbkId,
            cookie     : true,  // enable cookies to allow the server to access
            // the session
            xfbml      : true,  // parse social plugins on this page
            version    : 'v2.3' // use version 2.2
        });
        //FB.getLoginStatus(function(response) {
            //statusChangeCallback(response);
        //});

    };

    // Load the SDK asynchronously

    var url;
    function registerFB(){
        (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
        setTimeout(function() {
            FB.login(function(response){
                url = "/registerweb/newfb/"
                statusChangeCallback(response);
            }, {scope: 'public_profile, email, user_gender, user_birthday, user_location'});
        },500);
    }

    var photoAlbums;
    function doLogin() {
      $.post( url, { token: tokenId })
        .done(function(response) {
          console.log(response);
          if (response.status && response.status.errorCode >= 0) {
            var next = '';
            if (response.status.errorCode === 0) {
              console.log('next signup/city');
              console.log(response.status);
              next = "/web/signup/city";
            } else if (response.status.errorCode === 1) {
              console.log('next user.php/user');
              console.log(response);
              next = "/user.php/user";
            }
            window.location.href = next;
          } else if (response.status.errorCode < 0) {
            document.getElementById('email_error').style.display='';
            document.getElementById('email_error').innerHTML=response.status.errorMessage;
          }
        });
    }
